
<template>
  <span style="margin-left: 10px">
    <el-radio-group
      v-model="value"
      :disabled="disabled"
      :size="size"
      @change="changeList"
    >
      <el-radio
        v-for="item in infoData"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
        :name="item.value"
        >{{ item.label }}</el-radio
      >
      <el-button
        size="mini"
        type="text"
        @click="clearRadioSelect"
        >清空</el-button
      >
    </el-radio-group>
  </span>
</template>
<script>
export default {
  name: 'RadioGroup',
  props: {
    name: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'mini',
    },
  },
  data() {
    return {
      infoData: this.data,
      value: '',
    };
  },
  watch: {
    data: {
      handler(val) {
        return (this.infoData = val);
      },
    },
  },
  methods: {
    changeList(val) {
      this.$emit('change-list', val, this.name);
    },
    onReset() {
      this.value = '';
    },
    clearRadioSelect() {
      this.value = '';
      this.$emit('change-list', '', this.name);
    },
  },
};
</script>
<style lang="less" scoped>
</style>
